import React, { useState, useEffect } from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled, { useTheme } from 'styled-components';
import { _ as _taggedTemplateLiteral, c as _slicedToArray } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import { g as identity } from './_baseEach-3b97c1a8.js';
import './isArray-a3f14da2.js';
import './_Map-9acd9da3.js';
import { f as isSymbol } from './get-f58f8821.js';
import { b as baseIteratee } from './_baseIteratee-651c88ed.js';
import './index-7f6959fc.js';
import { L as Label } from './index-ae4b14fb.js';
import './head-b3f271d9.js';
import { _ as _map } from './map-651e82c0.js';
import './join-15b17329.js';
import './noop-d79f8d84.js';
import './isEmpty-9e4c9724.js';
import './wrapMediaQuery-d94fbf55.js';
import { S as SmallText } from './index-f96168ba.js';

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */


function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) {
      var computed = current,
          result = value;
    }
  }

  return result;
}

var _baseExtremum = baseExtremum;

/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

var _baseLt = baseLt;

/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */


function minBy(array, iteratee) {
  return array && array.length ? _baseExtremum(array, baseIteratee(iteratee), _baseLt) : undefined;
}

var minBy_1 = minBy;

/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */


function min(array) {
  return array && array.length ? _baseExtremum(array, identity, _baseLt) : undefined;
}

var min_1 = min;

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

var _baseGt = baseGt;

/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */


function max(array) {
  return array && array.length ? _baseExtremum(array, identity, _baseGt) : undefined;
}

var max_1 = max;

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  position: relative;\n  display: flex;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var SliderRail = styled.div(_templateObject(), function (_ref) {
  var sliderRail = _ref.theme.components.slider.sliderRail;
  return "\n    background-color: ".concat(sliderRail.colors.backgroundColor, ";\n    border-radius: ").concat(sliderRail.borders.radius, ";\n    height: ").concat(sliderRail.sizes.height, ";\n    width: ").concat(sliderRail.sizes.width, ";\n  ");
});

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  position: absolute;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var SliderStep = styled.span(_templateObject$1(), function (_ref) {
  var leftPosition = _ref.leftPosition,
      sliderStep = _ref.theme.components.slider.sliderStep;
  return "\n    background-color: ".concat(sliderStep.colors.backgroundColor, ";\n    height: ").concat(sliderStep.sizes.height, ";\n    left: ").concat(leftPosition + '%', ";\n    width: ").concat(sliderStep.sizes.width, ";\n    z-index: ").concat(sliderStep.elevations.zIndex, ";\n  \n    ").concat(SmallText, " {\n      display: flex;\n      justify-content: center;\n      margin-top: ").concat(sliderStep.title.margins.marginTop, ";\n    }\n  ");
});
SliderStep.propTypes = {
  leftPosition: PropTypes.number
};

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  cursor: pointer;\n  position: relative;\n  user-select: none;\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var SliderIndicator = styled.span(_templateObject$2(), function (_ref) {
  var leftPosition = _ref.leftPosition,
      moving = _ref.moving,
      sliderIndicator = _ref.theme.components.slider.sliderIndicator;
  return "\n    background-color: ".concat(sliderIndicator.colors.backgroundColor, ";\n    border-radius: ").concat(sliderIndicator.borders.radius, ";\n    height: ").concat(sliderIndicator.sizes.height, ";\n    width: ").concat(sliderIndicator.sizes.width, ";\n    left: ", "calc(".concat(leftPosition, "px - ").concat(sliderIndicator.sizes.width.slice(0, -2) / 2, "px)"), ";\n    transition: box-shadow ").concat(sliderIndicator.animation.animationDuration, " ").concat(sliderIndicator.animation.animationType, ";\n    z-index: ").concat(sliderIndicator.elevations.zIndex, ";\n    \n    ").concat(Label, "{\n      display: ").concat(moving ? 'block' : 'none', ";\n      // Calculate the label position by using theme sliderIndicator width minus the 'px' last 2 characters\n      right: ", "calc(".concat(sliderIndicator.sizes.width.slice(0, -2) / 2, "px - ").concat(sliderIndicator.valueLabel.width.slice(0, -2) / 2, "px)"), ";\n    }      \n    \n    ").concat(moving ? "box-shadow: ".concat(sliderIndicator.shadows.hover, ";") : "&:hover{\n        box-shadow: ".concat(sliderIndicator.shadows.moving, ";\n      }"), "\n  ");
});
SliderStep.propTypes = {
  leftPosition: PropTypes.number,
  moving: PropTypes["boolean"]
};

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  ", "\n  border-radius: 100%;\n  text-align: center;\n  box-shadow: 0px 2px 2px 1px rgba(0,0,0,0.55);\n  \n  @keyframes sliderValueAnimation{\n    0% {\n      opacity: 0;\n      transform: scale(0);\n      box-shadow: none;\n    }\n    100% {\n      opacity: 1;\n      transform: scale(1.00);\n    }\n  }\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var SliderValue = styled(Label)(_templateObject$3(), function (_ref) {
  var _ref$theme$components = _ref.theme.components.slider.sliderValue,
      animationDuration = _ref$theme$components.animationDuration,
      animationType = _ref$theme$components.animationType,
      backgroundColor = _ref$theme$components.backgroundColor,
      bottom = _ref$theme$components.bottom,
      color = _ref$theme$components.color,
      height = _ref$theme$components.height,
      width = _ref$theme$components.width;
  return "\n    animation: sliderValueAnimation ".concat(animationDuration, " ").concat(animationType, ";\n    background-color: ").concat(backgroundColor, ";\n    bottom: ").concat(bottom, ";\n    color: ").concat(color, ";\n    height: ").concat(height, ";\n    line-height: ").concat(height, ";\n    width: ").concat(width, ";\n  ");
});

function _templateObject$4() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var Slider = function Slider(_ref) {
  var isStepRestricted = _ref.isStepRestricted,
      isValueDisplayed = _ref.isValueDisplayed,
      onValueChange = _ref.onValueChange,
      step = _ref.step,
      range = _ref.range,
      steps = _ref.steps;

  var _useTheme = useTheme(),
      sliderRail = _useTheme.components.slider.sliderRail;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPressed = _useState2[0],
      setIsPressed = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      indicatorPos = _useState4[0],
      setIndicatorPos = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      xMousePosition = _useState6[0],
      setXMousePosition = _useState6[1];

  var pxSliderSize = sliderRail.sizes.width.slice(0, -2); // Add event regarding the indicator motion, remove it when Slider is unmounted

  useEffect(function () {
    if (window && isPressed) {
      window.addEventListener('mousemove', moveIndicatorEvent);
      window.addEventListener('mouseup', onMouseUp);
      return function () {
        window.removeEventListener('mousemove', moveIndicatorEvent);
        window.removeEventListener('mouseup', onMouseUp);
      };
    }
  }, [isPressed]);
  useEffect(function () {
    // Use onValue changed handler passed as a prop
    onValueChange && onValueChange(getSliderValueInPercent());
  }, [indicatorPos]);

  var onMouseUp = function onMouseUp() {
    return setIsPressed(false);
  };

  var onMouseDown = function onMouseDown(e) {
    setIsPressed(true); // Use the current mouse position on click,
    // minus the current slider position so it does not start from 0

    setXMousePosition(e.clientX - indicatorPos);
  }; // Calculate how much the mouse has moved on X axis relatively to the slider width


  var calculateIndicatorPos = function calculateIndicatorPos(currentXMousePosition) {
    var newPosition = max_1([min_1([currentXMousePosition - xMousePosition, pxSliderSize]), 0]);

    return newPosition;
  }; // List of ignored step that will not be displayed, but still be functional


  var ignoredSteps = [0, 100];

  var renderSteps = function renderSteps() {
    return _map(steps, function (step) {
      return (// Avoid display of 0 and 100 steps
        !ignoredSteps.includes(step.position) && React.createElement(SliderStep, {
          key: step.position,
          leftPosition: step.position
        }, React.createElement(SmallText, null, step.title))
      );
    });
  };

  var roundNumberToStep = function roundNumberToStep(num) {
    var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var inv = 1 / step;
    return Math.round(num * inv) / inv;
  }; // Use the range provided in props to adapt the value returned


  var getSliderValueInPercent = function getSliderValueInPercent() {
    return range[0] + roundNumberToStep(indicatorPos / pxSliderSize * (range[1] - range[0]), step);
  };

  var moveIndicatorEvent = function moveIndicatorEvent(e) {
    if (!isPressed) return;
    var newIndicatorPos = calculateIndicatorPos(e.clientX); // If values are restricted to steps, find the closest one

    if (steps && isStepRestricted) {
      // Calculate the position from the closest step
      // to the indicator value if it was not restricted
      newIndicatorPos = minBy_1(steps, function (s) {
        var mousePos = newIndicatorPos * 100 / pxSliderSize;
        return Math.abs(mousePos - s.position);
      }).position * pxSliderSize / 100;
    }

    setIndicatorPos(newIndicatorPos);
  };

  return React.createElement(SliderRail, null, React.createElement(SliderIndicator, {
    onMouseDown: onMouseDown,
    leftPosition: indicatorPos,
    moving: isPressed
  }, isValueDisplayed && React.createElement(SliderValue, null, Math.round(getSliderValueInPercent()))), steps && renderSteps());
};

Slider.defaultProps = {
  isStepRestricted: false,
  range: [0, 100],
  step: 1
};
Slider.propTypes = {
  isStepRestricted: PropTypes["boolean"],
  onValueChange: PropTypes.func,
  // The value step used to round the output value
  step: PropTypes.number,
  // Range of possible values
  range: PropTypes.array,
  // Steps infos displayed below the slider
  steps: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    position: PropTypes.number
  }))
};
/** @component */

var index = styled(Slider)(_templateObject$4());

export default index;
